module.exports = __webpack_public_path__ + "img/title.3edf76f7.png";